import CheckCircle from '@mui/icons-material/CheckCircle';
import CloseIcon from '@mui/icons-material/Close';
import {
  Box,
  Card,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import { useEffect } from 'react';
import { Link } from '~/components/Link';

import LinkedinFollowButton from '~/components/LinkedinFollowButton/LinkedinFollowButton';
import TwitterFollowButton from '~/components/TwitterFollowButton/TwitterFollowButton';

interface DownloadSuccessProps {
  open: boolean;
  onClose: () => void;
  file: string;
}

export default function DownloadSuccess({
  open,
  onClose,
  file,
}: DownloadSuccessProps) {
  useEffect(() => {
    if (file) {
      if (!window.open(file)) {
        if (
          window.confirm(
            'Your browser blocked this file from downloading. Click OK to try again.'
          )
        ) {
          window.open(file);
        }
      }
    }
  }, [file]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: { maxWidth: '500px' },
      }}>
      <Card>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
          }}>
          <CloseIcon />
        </IconButton>

        <DialogTitle>
          <Box sx={{ pt: 4 }}>
            <Typography variant="h5" textAlign="center">
              <CheckCircle
                color="success"
                fontSize="large"
                sx={{ verticalAlign: 'middle' }}
              />{' '}
              Your report is ready!
            </Typography>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Typography
            variant="h6"
            textAlign="center"
            sx={{ py: 4, fontWeight: 'normal' }}>
            If your report didn't open, you can{' '}
            <Link
              href={file}
              target="_blank"
              rel="noopener nofollow"
              sx={{ fontWeight: 'bold' }}>
              download it again
            </Link>
            .
          </Typography>
          <Divider />
          <Typography variant="body2" sx={{ fontWeight: 'normal' }}>
            Want to stay up to date? Follow Us
          </Typography>

          <Box sx={{ py: 1 }} display="flex" justifyContent="center" gap={1}>
            <LinkedinFollowButton />
            <TwitterFollowButton />
          </Box>
        </DialogContent>
      </Card>
    </Dialog>
  );
}
